<div class="study-file-notification" [hidden]="viewMode !== 'NotificationDetail'" *ngIf="recipients.length > 0">
  <app-notification-template #primaryRef [allowGrouping]="false"
                             [allowDisableSubmit]="false"
                             [inputRecipients]="recipients"
                             [inputMessageTemplate]="messageTemplate"
                             (onSubmit)="onSubmit()"
                             (onCancel)="onCancel()"></app-notification-template>
</div>
<div class="study-file-notification" [hidden]="viewMode !== 'Submit'">

  <div class="modal-header">
    <div class="d-flex justify-content-end ms-auto">

      <div class="d-flex flex-direction-column text-center" style="margin-top:2px"
           [ngClass]="{'disable-container': messageTemplate.notificationTypeId == 0}" *ngIf="recipients.length > 0">
        Submitting Vet
        <span class="btn btn-outline-primary d-flex">
          <input type="checkbox" [(ngModel)]="allChecked" id="autoNotifySub"
                 class="me-2" />
          <label class="clickable-label" (click)="changeViewModeToNotification()">
            Auto Notify
            ({{recipientsCount}}) Vet
          </label>
        </span>
      </div>
      <button class="btn btn-secondary ms-2 me-2" style="margin-top: 26px;" type="button" (click)="modal.dismiss('Cross click')">Cancel</button>
      <button style="margin-top: 26px;" *ngIf="data.statusId==3" type="button" class="btn btn-primary btn-primary-color" (click)="UpdateStatus()"
              [disabled]="!this.form.valid">
        Deny
      </button>
      <button style="margin-top: 26px;" *ngIf="data.statusId==4" type="button" class="btn btn-primary btn-primary-color"
              (click)="UpdateStatus()" [disabled]="!this.form.valid">
        Approve
      </button>

    </div>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="warning-panel" *ngIf="messageTemplate.notificationTypeId == 0">
          <span class="icon">⚠️</span>
          <span class="message">
            A notification message template isn't defined, so notifications cannot be
            sent at this time.
          </span>
          <button class="dismiss-btn" onclick="this.parentElement.style.display='none'">✖</button>
        </div>
      </div>
    </div>

    <div class="px-4 py-2">
      <h4 class="denial-heading" *ngIf="data.statusId==3">Reason for Denial</h4>
      <h4 class="denial-heading" *ngIf="data.statusId==4">Approval Comments</h4>
      <form [formGroup]="form">
        <textarea id="reason" name="reason" rows="4" cols="50" class="form-control" formControlName="reason"></textarea>
      </form>
    </div>
  </div>

</div>
